<template>
  <v-dialog
    v-model="showing"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="text-h5">
        Informe Sua Localização!
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-form ref="location">
          <p>
            Informe sua localização para que possamos lhe ajudara a encontrar
            lojas próximas!
          </p>
          <v-select
            solo
            dense
            label="Estado"
            v-model="location.state"
            item-text="name"
            item-value="id"
            :items="states"
            :rules="[$rules.required]"
            :loading="loadingStates"
          />
          <v-select
            solo
            dense
            label="Cidade"
            v-model="location.city"
            item-text="name"
            item-value="id"
            :items="cities"
            :rules="[$rules.required]"
            :disabled="loadingCities"
            no-data-text="Selecione primeiro o estado"
          />
          <v-divider />
          <v-card-actions class="justify-end d-flex">
            <v-btn color="#4B2A66" dark  @click="saveLocation()">
              Salvar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "GetLocation",
  data: () => ({
    showing: false,
    location: {
      city: -1,
      state: -1,
    },
    cities: [],
    states: [],
    loadingStates: false,
    loadingCities: false,
  }),
  methods: {
    open(){
      this.showing = true
    },
    loadLocation() {
      const localStorageLocation = localStorage.getItem("VisitorLocation");
      if (localStorageLocation){
        this.location = JSON.parse(localStorageLocation)
        this.$emit("haveCity", this.location.city);
      } else {
        this.showing = true
      }
    },
    saveLocation() {
      if (this.$refs.location.validate()) {
        localStorage.setItem(
          "VisitorLocation",
          JSON.stringify(this.location)
        );
        this.$emit("haveCity", this.location.city);
        this.showing = false
      }
    },
    loadStates(){
      this.loadingStates = true;
      this.$axios.get("/states").then((response) => {
        this.states = response.data;
        this.loadingStates = false;
      });
    },
    loadCities(){
      this.loadingCities = true;
      this.$axios.get(`/cities/${this.location.state}`).then((response) => {
        this.cities = response.data;
        this.loadingCities = false;
      });
    },
  },
  mounted() {
    this.loadStates()
    if (!this.$store.state.logged){
      this.loadLocation()
    }
  },
  watch: {
    "location.state"(state_id) {
      if (!state_id || state_id == -1) {
        this.cities = [];
      } else {
        this.loadCities()
      }
    },
  },
};
</script>
